import React from 'react';
import { ObjectSchema } from 'yup';

import { FormValidation } from '../../../../_common/context/BookingContext';
import { FieldsListQuery_category_fields as Field } from '../../../../types/api';
import { GroupT } from '../types';

import FieldDefinition from './FieldDefinition';

interface Props {
  fieldDefinitions: Array<GroupT | Field>;
  validationSchema: ObjectSchema<object>;
  submitting: boolean;
  groupDirection?: 'row' | 'column';
  validationType?: FormValidation;
}

export default function CollapsedForm({
  fieldDefinitions,
  validationSchema,
  validationType,
}: Props) {
  return (
    <>
      {fieldDefinitions.map((fieldDefinition) => (
        <FieldDefinition
          fieldDefinition={fieldDefinition}
          groupDirection={
            fieldDefinition.inputType === 'GROUP' ? 'row' : undefined
          }
          key={`${fieldDefinition.id}_${validationType}`}
          validationSchema={validationSchema}
        />
      ))}
    </>
  );
}
